import Joi from 'joi';
import {
	api as apiRequest,
	batchApi as batchApiRequest
} from '@culture/common-helpers/request';
import { addCleanCache } from '@culture/common-helpers/params';
import Template from 'pageTemplates/pushkinsCard/main';

const Main = (props) => <Template {...props} />;

export async function getServerSideProps({ query }) {
	const validationSchema = Joi.object().keys({
		cleanCache: Joi.boolean().failover(false)
	});

	const params = Joi.attempt(query, validationSchema, {
		stripUnknown: true
	});

	const rubricPath = 'pushkinskaya-karta';

	const [
		{
			items: [rubric]
		},
		{ items: events }
	] = await batchApiRequest([
		apiRequest(
			'rubrics',
			addCleanCache(
				{
					paths: [rubricPath],
					withHidden: true,
					cached: true
				},
				params.cleanCache
			)
		),
		apiRequest(
			'actualEvents',
			addCleanCache(
				{
					isPushkinsCard: true,
					limit: 10,
					statuses: ['published'],
					isSortByNearestSeance: true,
					fields: [
						'title',
						'name',
						'thumbnailFile',
						'genres',
						'places.locale.sysName',
						'places.title',
						'places.seanceEndDate',
						'places.institute',
						'seances.placeIndex',
						'seances.startDate',
						'seances.endDate',
						'seanceStartDate'
					].join(),
					cached: true
				},
				params.cleanCache
			)
		)
	]);

	return {
		props: {
			rubric,
			events
		}
	};
}

export default Main;
